$(document).ready(function () {
    // Main menu dropdown
    $('.menu .dropdown a').hover(function () {
        if (!is_touch_device()) {
            let subMenu = $(this).parent().find('.sub-menu');

            if (subMenu.hasClass('full-width-sub-menu')) {
                subMenu.fadeIn(250).css('display','grid');
            } else {
                subMenu.fadeIn(250);
            }
        }
    }, function () {
        if (!is_touch_device())
            $(this).parent().find('.sub-menu').hide();
    });

    $('.menu .dropdown a > i').click(function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var $this = $(this);
        var subMenu = $this.parent().next('.sub-menu');

        requestAnimationFrame(function () {
            if (subMenu.is(':visible')) {
                subMenu.hide();
                $this.attr('class', 'fa fa-angle-down');
            } else {
                subMenu.fadeIn(250);
                $this.attr('class', 'fa fa-angle-up');
            }
        });
    });

    $('.sub-menu').hover(function () {
        $(this).parent().find('> a').addClass('active');
        $(this).show();
    }, function () {
        $(this).parent().find('> a').removeClass('active');
        $(this).hide();
    });

    // Language picker
    $('.language-picker').hover(function () {
        $('#language-list').fadeIn(250);
    }, function () {
        $('#language-list').hide();
    });

    // Disable click on items with class disable
    $(".disabled").click(function (e) {
        e.preventDefault();
    });

    // Bindings for toggle dropdowns in top-icons-block
    bindToggleButtons();

    // Reset menus when somewhere in the page there is a click
    $(document).click(function (e) {
        resetToggles();
    });
});

function is_touch_device() {
    return !!('ontouchstart' in window);
}

$(document).on("click", ".update-wishlist", function (e) {
    e.preventDefault();
    let wishlist = $(this).data("wishlist"),
        model = $(this).data("model"),
        style = $(this).data("style"),
        current_action = $(this).data("action"),
        type = $(this).data("type"),
        url = "",
        text_after = $(this).data("text-after-click"),
        globalsearch = $('#globalsearch-'+wishlist),
        globalsearchvalue = [],
        current_val = "";

    if (current_action === "delete") {
        url = route('wishlists.remove-model-from-active-wishlist', { model_no: model });
    } else {
        document.dispatchEvent(new CustomEvent('TweakwiseAddToWishlist',  {
            detail: {
                product: $(this).data('tweakwise-item-id'),
            }
        }));

        url = route('wishlists.add-model-to-active-wishlist', { model_no: model });
    }
    if (style != '') {
        url = url + "/" + style
    }

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: url,
        success: $.proxy(function (data) {
            if (!data || !data.success) {
                return;
            }

            let $this = $(this);
            if (type === "ordermatrix") {
                let wishListIcon = $this.find("i");

                if (current_action === "delete") {
                    wishListIcon.removeClass("fas");
                    wishListIcon.addClass("far");
                    $this.data("action", "add");
                    $this.removeClass("active");
                } else {
                    wishListIcon.removeClass("far");
                    wishListIcon.addClass("fas");
                    $this.data("action", "delete");
                    $this.addClass("active");
                }

                let $eTarget = $(e.target);
                if ($eTarget.attr('data-text-after-click')) {
                    if ($eTarget.is("button")) {
                        current_val = $this.html();
                        $this.html(text_after);
                        $this.data("text-after-click", current_val);
                    } else if ($eTarget.is("i")) {
                        current_val = $this.prop("title");
                        $this.prop("title", text_after);
                        $this.data("text-after-click", current_val);
                    }
                }
            }

            if (type === "wishlist" && current_action === "delete") {
                $this.closest(".wishlist-item-wrapper").remove();
                globalsearchvalue = globalsearch.val().split(',');
                globalsearchvalue = globalsearchvalue.filter(function (item) {
                    return item.trim() !== model.toString();
                });
                globalsearch.val(globalsearchvalue.join(','));
            }
        }, this)
    });
});

// Toggle search area on mobile (<= 576)
$(document).on('click', 'a.top-icon.top-btn.search, .search-input-wrapper .btn.close-btn', function (e) {
    e.preventDefault();

    let searchArea = $('.search-area'),
        header     = $('#header');

    if ($(window).width() <= 576) {
        searchArea.toggleClass('show');
        header.toggleClass('search-active');
    } else {
        searchArea.show();
        header.removeClass('search-active');
    }
});

// Functions and vars for toggle dropdowns in top-icons-block

// Array of toggleable items
var toggle_items = [
    'user',
    'bag',
    'lang'
];

/**
 * Binds the click event to the items in the toggle_items array
 */
function bindToggleButtons() {
    $.each(toggle_items, function (key, value) {
        $('#' + value + '-dropdown').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            resetToggles(value);

            toggleIconClass('#' + value + '-dropdown', 'fa-caret-down', 'fa-caret-up');
            $('#top-icon-' + value + '-dropdown').toggle();
        });
    });
}

/**
 * Toggle class icon_one and icon_two on element
 *
 * @param  string element  element id with #
 * @param  string icon_one classname without dot
 * @param  string icon_two classname without dot
 */
function toggleIconClass(element, icon_one, icon_two) {
    found_one = $(element + ' .' + icon_one);

    if (found_one.length > 0) {
        found_one.removeClass(icon_one);
        found_one.addClass(icon_two);
    } else {
        found_two = $(element + ' .' + icon_two);

        found_two.removeClass(icon_two);
        found_two.addClass(icon_one);
    }
}

/**
 * Resets an icon to its default class
 *
 * @param  string element  element id with #
 * @param  string icon classname without dot
 * @param  string def_icon classname without dot
 */
function resetIconClass(element, icon, def_icon) {
    find = $(element + ' .' + icon);

    if (find.length > 0) {
        find.removeClass(icon);
        find.addClass(def_icon);
    }
}

/**
 * Resets all toggle panels on the page based
 * on the array of values
 *
 * @param  string skip classname of icon to skip
 */
function resetToggles(skip) {
    $.each(toggle_items, function (key, value) {
        if (value !== skip) {
            resetIconClass('#' + value + '-dropdown', 'fa-caret-up', 'fa-caret-down');
            $('#top-icon-' + value + '-dropdown').hide();
        }
    });
}

function handleTermDeltionIcon(e) {
    const clearBtn = document.querySelector('.clear-btn');

    clearBtn.style.color = window.getComputedStyle(e).color;
    clearBtn.style.display = e.value ? 'block' : 'none';
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.search-area input[type="search"]')) {
        window.setTimeout(() => {
            handleTermDeltionIcon(document.querySelector('.search-area input[type="search"]'));
        }, 1000);

        document.querySelector('.search-area input[type="search"]').addEventListener('input', function () {
            handleTermDeltionIcon(this);
        });

        document.querySelector('.search-area .clear-btn').addEventListener('click', function () {
            const searchInput = document.querySelector('.search-area input[type="search"]');

            searchInput.value = ''; // Clear the input
            searchInput.focus();    // Optionally refocus the input
            this.style.display = 'none'; // Hide the clear button
        });
    }
});
